(function () {
  'use strict';

  // Collection markup can be moved by legacy jQuery or reloaded by the editor.
  if (window.minetanFilterSyncInitialized) return;
  window.minetanFilterSyncInitialized = true;

  var mobile = window.matchMedia('(max-width: 1023px)');
  var activeForm = null;
  var returnFocus = null;
  var groupOpener = null;
  var restoreHiddenWidgets = null;

  function isFilterForm(form) {
    return form && form.matches('.collection-filter-hold .filter-form');
  }

  function each(nodes, callback) {
    Array.prototype.forEach.call(nodes, callback);
  }

  function setInert(element, hidden) {
    // Salesforce also defines Element.inert in browsers with native HTMLElement.inert.
    // Keep its focus bookkeeping in sync, as the cart drawer does.
    var descriptor = Object.getOwnPropertyDescriptor(Element.prototype, 'inert');
    if (descriptor && descriptor.set) descriptor.set.call(element, hidden);
    else element.inert = hidden;
  }

  function configure(form) {
    var open = mobile.matches && form.classList.contains('show');
    var sub = form.querySelector('.mobile-sub-filters');
    var nested = open && sub && sub.classList.contains('show');
    var trigger = form.closest('.collection-filter-hold').querySelector('.toggle-filters');
    trigger.setAttribute('aria-expanded', String(open));
    // Release the previous layer before hiding another. Overlapping parent/child
    // inert roots make the legacy polyfill remember already-disabled tab stops.
    each(form.children, function (child) { setInert(child, false); });
    setInert(form, false);
    if (mobile.matches && !open) setInert(form, true);
    else if (open) {
      each(form.children, function (child) {
        setInert(child, child === sub ? !nested : !!nested);
      });
    }
    if (mobile.matches) {
      form.setAttribute('role', 'dialog');
      form.setAttribute('aria-hidden', String(!open));
    } else {
      form.removeAttribute('role');
      form.removeAttribute('aria-hidden');
    }
    if (open) form.setAttribute('aria-modal', 'true');
    else form.removeAttribute('aria-modal');
  }

  function focusable(panel) {
    return Array.prototype.filter.call(panel.querySelectorAll(
      'button, a[href], input, select, textarea, summary, [tabindex]'
    ), function (element) {
      return !element.disabled && element.tabIndex >= 0 && !element.closest('[inert]') &&
        element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden';
    });
  }

  function currentPanel() {
    var sub = activeForm.querySelector('.mobile-sub-filters.show');
    return sub || activeForm;
  }

  function focusFirst() {
    var panel = currentPanel();
    (focusable(panel)[0] || activeForm).focus({ preventScroll: true });
  }

  function hideWidgets() {
    if (!restoreHiddenWidgets) restoreHiddenWidgets = window.minetanFloatingWidgets.hide();
  }

  function restoreWidgets() {
    if (restoreHiddenWidgets) restoreHiddenWidgets();
    restoreHiddenWidgets = null;
  }

  function closeGroups(form) {
    each(form.querySelectorAll('details[open]'), function (detail) { detail.open = false; });
    form.querySelector('.mobile-sub-filters').classList.remove('show');
  }

  function closeDrawer(restoreFocus) {
    if (!activeForm) return;
    var form = activeForm;
    var trigger = returnFocus;
    activeForm = null;
    returnFocus = null;
    groupOpener = null;
    form.classList.remove('show');
    closeGroups(form);
    configure(form);
    restoreWidgets();
    if (restoreFocus && trigger && trigger.isConnected) trigger.focus({ preventScroll: true });
  }

  function openDrawer(form, trigger) {
    if (activeForm) closeDrawer(false);
    closeGroups(form);
    activeForm = form;
    returnFocus = trigger;
    form.classList.add('show');
    configure(form);
    hideWidgets();
    focusFirst();
  }

  function backToFilters(form) {
    var summary = groupOpener;
    groupOpener = null;
    closeGroups(form);
    configure(form);
    if (summary && summary.isConnected) summary.focus({ preventScroll: true });
    else focusFirst();
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('.collection-filter-hold .toggle-filters');
    if (trigger && mobile.matches) {
      event.preventDefault();
      var form = trigger.closest('.collection-filter-hold').querySelector('.filter-form');
      if (activeForm === form) closeDrawer(true);
      else openDrawer(form, trigger);
      return;
    }
    var control = event.target.closest('.filter-form .close-btn, .filter-form .back-arrow');
    if (!control || !isFilterForm(control.form)) return;
    event.preventDefault();
    if (control.classList.contains('back-arrow')) backToFilters(control.form);
    else closeDrawer(true);
  });

  document.addEventListener('toggle', function (event) {
    var detail = event.target;
    if (!detail.matches('details.filter-group')) return;
    var form = detail.closest('.filter-form');
    if (!isFilterForm(form) || !detail.open) return;
    var groups = form.querySelectorAll('details.filter-group');
    var index = Array.prototype.indexOf.call(groups, detail);
    each(groups, function (other) { if (other !== detail) other.open = false; });
    if (!mobile.matches || activeForm !== form) return;
    var sub = form.querySelector('.mobile-sub-filters');
    var nested = sub.querySelectorAll('details.filter-group-mobile')[index];
    if (!nested) return;
    each(sub.querySelectorAll('details.filter-group-mobile'), function (other) { other.open = other === nested; });
    groupOpener = detail.querySelector('summary');
    sub.classList.add('show');
    configure(form);
    focusFirst();
  }, true);

  document.addEventListener('keydown', function (event) {
    if (!activeForm) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      event.stopPropagation();
      closeDrawer(true);
    } else if (event.key === 'Tab') {
      var items = focusable(currentPanel());
      var first = items[0];
      var last = items[items.length - 1];
      if (!first) {
        event.preventDefault();
        activeForm.focus({ preventScroll: true });
      } else if (!items.includes(document.activeElement) ||
        (event.shiftKey && document.activeElement === first) ||
        (!event.shiftKey && document.activeElement === last)) {
        event.preventDefault();
        (event.shiftKey ? last : first).focus({ preventScroll: true });
      }
    }
  }, true);

  document.addEventListener('focusin', function (event) {
    if (activeForm && !currentPanel().contains(event.target)) focusFirst();
  });

  // Desktop filters remain independent dropdowns and close on outside click.
  document.addEventListener('click', function (event) {
    if (mobile.matches) return;
    each(document.querySelectorAll('.filter-form details.filter-group[open]'), function (detail) {
      if (!detail.contains(event.target)) detail.open = false;
    });
  }, true);

  function syncFilter(event) {
    var source = event.target;
    var form = source.form;
    if (!isFilterForm(form) || !source.name || source.name.indexOf('filter.') !== 0) return;
    each(form.elements, function (field) {
      if (field === source || field.name !== source.name) return;
      if (source.type === 'checkbox') {
        if (field.value === source.value) field.checked = source.checked;
      } else field.value = source.value;
    });
  }
  document.addEventListener('input', syncFilter);
  document.addEventListener('change', function (event) {
    syncFilter(event);
    var field = event.target;
    if (!isFilterForm(field.form) || field.name !== 'sort_by') return;
    if (!field.form.querySelector('.filter-footer').getClientRects().length) field.form.requestSubmit();
  });

  // Native FormData also covers submissions initiated by legacy jQuery.
  document.addEventListener('formdata', function (event) {
    if (!isFilterForm(event.target)) return;
    var data = event.formData;
    var names = [];
    data.forEach(function (value, name) {
      if (name.indexOf('filter.') === 0 && names.indexOf(name) === -1) names.push(name);
    });
    names.forEach(function (name) {
      var values = data.getAll(name);
      data.delete(name);
      values.forEach(function (value, index) {
        if (values.indexOf(value) === index) data.append(name, value);
      });
    });
  }, true);

  function configureAll() {
    each(document.querySelectorAll('.collection-filter-hold .filter-form'), configure);
  }
  mobile.addEventListener('change', function () {
    // A panel must not keep focus trapped after changing to the desktop layout.
    closeDrawer(false);
    configureAll();
  });
  document.addEventListener('shopify:section:load', configureAll);
  document.addEventListener('shopify:section:unload', function (event) {
    if (activeForm && event.target.contains(activeForm)) closeDrawer(false);
  });
  // Browser history can restore form values from the page we navigated away
  // from. Match the controls to the filters and products rendered by Shopify.
  function restoreAppliedFilters() {
    closeDrawer(false);
    each(document.querySelectorAll('.collection-filter-hold .filter-form'), function (form) {
      each(form.elements, function (field) {
        if (field.type === 'checkbox' || field.type === 'radio') field.checked = field.defaultChecked;
        else if (field.tagName === 'SELECT') {
          var selected = Array.prototype.find.call(field.options, function (option) { return option.defaultSelected; });
          field.value = field.getAttribute('data-applied-sort') || (selected || field.options[0]).value;
        } else if (field.name && field.name.indexOf('filter.') === 0) field.value = field.defaultValue;
      });
    });
    configureAll();
  }
  function scheduleFilterRestore() { setTimeout(restoreAppliedFilters, 0); }
  window.addEventListener('pageshow', scheduleFilterRestore);
  window.addEventListener('popstate', scheduleFilterRestore);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', configureAll);
  else configureAll();
})();
